import produce, { Draft } from 'immer';

import { ILogout, ISetConfigurableUser, ISetLoggedIn, ISetTokenChecked } from '../../actions/auth';
import * as actionTypes from '../../constants/actionTypes';
import Auth from '../../lib/auth';
import { Claims, SentinelUser } from '../../meta/types/user';

export const initialState = Object.freeze({
  isLoggedIn: false,
  tokenChecked: false,
  rootManaging: false,
});

export type AuthState = typeof initialState & {
  authenticatedUser?: Claims;
  configurableUser?: SentinelUser;
};

type AuthAction = ISetTokenChecked | ISetLoggedIn | ILogout | ISetConfigurableUser;

const auth = (state: AuthState = initialState, action: AuthAction) => {
  return produce<AuthState>(state, (draft: Draft<AuthState>) => {
    switch (action.type) {
      case actionTypes.SET_CONFIGURABLE_USER:
        draft.configurableUser = action.user;
        return;
      case actionTypes.LOGOUT:
        Auth.deleteAuthorization();
        draft.isLoggedIn = false;
        draft.configurableUser = undefined;
        draft.authenticatedUser = undefined;
        return;
      case actionTypes.SET_TOKEN_CHECKED:
        draft.tokenChecked = action.tokenChecked;
        return;
      case actionTypes.SET_LOGGED_IN:
        const { user } = action;
        draft.tokenChecked = true;
        draft.configurableUser = user;
        draft.isLoggedIn = true;
        draft.authenticatedUser = action.impersonatorClaims;
        draft.rootManaging = action.rootManaging;
        return;
      default:
        return;
    }
  });
};

export default auth;
